// extracted by mini-css-extract-plugin
export default {"mainContainer":"shoppingFeatures_mainContainer__p+1Ym","container":"shoppingFeatures_container__GfLLY","items":"shoppingFeatures_items__2qrcp","icon":"shoppingFeatures_icon__bISFW"};